module.exports = __webpack_public_path__ + "img/22.0c6629de.png";